import { useTheme } from '@/state/theme-context';

import styles from './theme-toggle.module.css';

import type { JSX } from 'react';

export function ThemeToggle(): JSX.Element {
  const { theme, toggleTheme } = useTheme();
  return (
    <button
      type="button"
      className={styles['btn']}
      onClick={toggleTheme}
      /* Names the ACTION, not a pressed state: `aria-pressed` on a control whose
         label already flips would announce "switch to light theme, pressed",
         which is two contradictory readings of one control. The current theme
         is exposed as data instead, so an E2E spec has something stable to bind
         to while the accessible name keeps changing. */
      aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      data-theme-toggle=""
      data-theme={theme}
    >
      {theme === 'dark' ? 'Light' : 'Dark'}
    </button>
  );
}
